import { render, staticRenderFns } from "./CreateCurriculumModal.vue?vue&type=template&id=d923f594&scoped=true"
import script from "./CreateCurriculumModal.vue?vue&type=script&lang=js"
export * from "./CreateCurriculumModal.vue?vue&type=script&lang=js"
import style0 from "./CreateCurriculumModal.vue?vue&type=style&index=0&id=d923f594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d923f594",
  null
  
)

export default component.exports